(function (globalScope, factory) {
  var api = factory();

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = api;
  }

  if (globalScope) {
    globalScope.theme = globalScope.theme || {};
    globalScope.theme.bundleCart = api;
    globalScope.theme.byo2Cart = api.byo2;
  }
})(typeof window !== 'undefined' ? window : null, function () {
  'use strict';

  var BUNDLE_ID_PATTERN = /^[A-Za-z0-9_-]{1,64}$/;
  var POSITIVE_INTEGER_PATTERN = /^[1-9]\d*$/;
  var BYO_BUNDLE_NUMBER_KEY = 'BYO Bundle #';
  var MONTHLY_BUNDLE_NUMBER_KEY = 'Monthly Bundle #';
  // Monthly and Secret Menu Monthly envelopes, each linking to its own page.
  var MONTHLY_CARRIER_URLS = {
    '48914860048616': '/products/monthly-pill-case-bundle',
    '50512484303080': '/products/secret-menu-monthly-pill-case-bundle'
  };
  var MONTHLY_CARRIER_PRODUCT_ID = '9602892431592';
  var MONTHLY_CASE_PRODUCT_ID = '9105064198376';
  var MONTHLY_LID_PRODUCT_ID = '9127873478888';
  var MONTHLY_POCKET_PRODUCT_ID = '9110283780328';
  var MONTHLY_SIZE_NAMES = {
    WXSPC: 'Weekly XS Case',
    WPC: 'Weekly Pill Case',
    WVC: 'Weekly Vitamin Case',
    WVXC: 'Weekly Vitamin XL Case',
    WV2XC: 'Weekly Vitamin 2XL Case'
  };
  // Monthly engraving lives on the shared survivor listings, one variant per case size.
  var MONTHLY_LID_RULES = {
    WXSPC: { id: '49100613779688', sku: 'ENG-LID-WXSPC-MNTH' },
    WPC: { id: '49100613812456', sku: 'ENG-LID-WPC-MNTH' },
    WVC: { id: '49100613845224', sku: 'ENG-LID-WVC-MNTH' },
    WVXC: { id: '49100613877992', sku: 'ENG-LID-WVXC-MNTH' },
    WV2XC: { id: '49100613910760', sku: 'ENG-LID-WV2XC-MNTH' }
  };
  var MONTHLY_POCKET_RULES = {
    WXSPC: { id: '49100613943528', sku: 'ENG-IPE-WXSPC-MNTH' },
    WPC: { id: '49100613976296', sku: 'ENG-IPE-WPC-MNTH' },
    WVC: { id: '49100614009064', sku: 'ENG-IPE-WVC-MNTH' },
    WVXC: { id: '49100614041832', sku: 'ENG-IPE-WVXC-MNTH' },
    WV2XC: { id: '49100614074600', sku: 'ENG-IPE-WV2XC-MNTH' }
  };
  var BYO_ROLE_ORDER = {
    case: 0,
    free_nano: 1,
    lid: 2,
    pocket: 3,
    gift: 4
  };
  var BYO_CARRIER_RULES = {
    '48914859950312': { packCount: 2, freeNanoAllowance: 0 },
    '48914859983080': { packCount: 3, freeNanoAllowance: 0 },
    '48914860015848': { packCount: 2, freeNanoAllowance: 1 },
    // Secret Menu 2-Pack and 3-Pack.
    '50512484237544': { packCount: 2, freeNanoAllowance: 0 },
    '50512484270312': { packCount: 3, freeNanoAllowance: 0 }
  };

  function positiveInteger(value) {
    var normalized = String(value == null ? '' : value);
    if (!POSITIVE_INTEGER_PATTERN.test(normalized)) return null;
    var parsed = parseInt(normalized, 10);
    return Number.isSafeInteger(parsed) ? parsed : null;
  }

  function propertiesFor(item) {
    return item && item.properties && typeof item.properties === 'object' ? item.properties : {};
  }

  function rawMarkerFor(item) {
    var value = propertiesFor(item)._ikg_bundle;
    return typeof value === 'string' ? value.trim() : '';
  }

  function isModernMarker(value) {
    if (typeof value !== 'string') return false;
    var parts = value.trim().split(':');
    var family = parts[0];
    var bundleId = parts[1];
    if (!BUNDLE_ID_PATTERN.test(bundleId || '')) return false;

    if (family === 'mag2') {
      return parts.length === 2
        || (parts.length === 3 && ['case', 'lid', 'pocket', 'travel'].includes(parts[2]));
    }
    if (family === 'mset2') {
      return parts.length === 2
        || (parts.length === 3 && ['lid', 'pocket', 'ultem', 'packaging'].includes(parts[2]))
        || (parts.length === 4 && parts[2] === 'case' && ['left', 'middle', 'right'].includes(parts[3]));
    }
    if (family === 'com2') {
      return parts.length === 2
        || (parts.length === 3 && ['lid', 'pocket', 'ultem', 'gift'].includes(parts[2]));
    }
    if (family === 'com3') {
      return parts.length === 2
        || (parts.length === 4
          && POSITIVE_INTEGER_PATTERN.test(parts[2] || '')
          && [
            'am_case',
            'pm_case',
            'week1_case',
            'week2_case',
            'left_case',
            'right_case',
            'lid',
            'pocket',
            'ultem',
            'gift'
          ].includes(parts[3]));
    }
    if (family === 'byo2') return !!parseByoMarker(value);
    if (family === 'mon2') return !!parseMonthlyMarker(value);
    return false;
  }

  function isQuantityLocked(item) {
    return isModernMarker(rawMarkerFor(item)) || parentKeyFor(item) !== '';
  }

  function variantIdFor(item) {
    var value = item && (item.variant_id || item.variantId || item.id || (item.variant && item.variant.id));
    return String(value == null ? '' : value).split('/').pop();
  }

  function productIdFor(item) {
    var value = item && (item.product_id || item.productId || (item.product && item.product.id));
    return String(value == null ? '' : value).split('/').pop();
  }

  function skuFor(item) {
    return String(item && (item.sku || (item.variant && item.variant.sku)) || '').trim();
  }

  function isMonthlyCarrier(item) {
    return Object.prototype.hasOwnProperty.call(MONTHLY_CARRIER_URLS, variantIdFor(item));
  }

  function parentKeyFor(item) {
    var relationship = item && (item.parent_relationship || item.parentRelationship);
    return String(relationship && (
      relationship.parent_key
      || relationship.parentKey
      || (relationship.parent && relationship.parent.key)
    ) || '');
  }

  function quantityFor(item) {
    return Number(item && item.quantity) || 0;
  }

  function lineAmount(item, lineField, unitField) {
    if (item && Number.isFinite(Number(item[lineField]))) return Number(item[lineField]);
    var unitAmount = item && Number.isFinite(Number(item[unitField])) ? Number(item[unitField]) : 0;
    return unitAmount * quantityFor(item);
  }

  function originalLineAmount(item) {
    if (item && Number.isFinite(Number(item.original_line_price))) return Number(item.original_line_price);
    if (item && Number.isFinite(Number(item.original_price))) return Number(item.original_price) * quantityFor(item);
    return lineAmount(item, 'line_price', 'price');
  }

  function parseByoMarker(value) {
    if (typeof value !== 'string') return null;
    var parts = value.trim().split(':');
    if (parts[0] !== 'byo2' || !BUNDLE_ID_PATTERN.test(parts[1] || '')) return null;

    var carrierVariantId = parts[2];
    var packCount = positiveInteger(parts[3]);
    var role = parts[4];
    if (!POSITIVE_INTEGER_PATTERN.test(carrierVariantId || '') || (packCount !== 2 && packCount !== 3)) return null;

    if (parts.length === 5 && role === 'parent') {
      return { family: 'byo2', bundleId: parts[1], carrierVariantId: carrierVariantId, packCount: packCount, role: role, slot: 0, component: 0 };
    }
    if (parts.length === 5 && ['lid', 'pocket', 'free_nano', 'gift'].includes(role)) {
      return { family: 'byo2', bundleId: parts[1], carrierVariantId: carrierVariantId, packCount: packCount, role: role, slot: 0, component: 0 };
    }
    if (parts.length !== 7 || role !== 'case') return null;
    var slot = positiveInteger(parts[5]);
    var component = positiveInteger(parts[6]);
    if (!slot || slot > packCount || !component) return null;
    return { family: 'byo2', bundleId: parts[1], carrierVariantId: carrierVariantId, packCount: packCount, role: role, slot: slot, component: component };
  }

  function parseMonthlyMarker(value) {
    if (typeof value !== 'string') return null;
    var parts = value.trim().split(':');
    if (parts[0] !== 'mon2' || !BUNDLE_ID_PATTERN.test(parts[1] || '')) return null;
    if (parts.length === 2) return { family: 'mon2', bundleId: parts[1], role: 'parent', slot: 0 };
    if (parts.length === 3 && (parts[2] === 'lid' || parts[2] === 'pocket')) {
      return { family: 'mon2', bundleId: parts[1], role: parts[2], slot: 0 };
    }
    if (parts.length === 4 && parts[2] === 'case' && /^[1-4]$/.test(parts[3])) {
      return { family: 'mon2', bundleId: parts[1], role: 'case', slot: Number(parts[3]) };
    }
    return null;
  }

  function parseMarker(value) {
    return parseMonthlyMarker(value) || parseByoMarker(value);
  }

  function sameByoIdentity(left, right) {
    return !!left && !!right
      && left.bundleId === right.bundleId
      && left.carrierVariantId === right.carrierVariantId
      && left.packCount === right.packCount;
  }

  function isAuthorizedByoParent(item, marker) {
    var rule = marker && BYO_CARRIER_RULES[marker.carrierVariantId];
    return !!rule
      && marker.role === 'parent'
      && rule.packCount === marker.packCount
      && variantIdFor(item) === marker.carrierVariantId
      && quantityFor(item) === 1
      && lineAmount(item, 'final_line_price', 'final_price') === 0
      && !item.selling_plan_allocation
      && !parentKeyFor(item);
  }

  function magnanoSlots(parent, lines, packCount) {
    var marker = parseByoMarker(rawMarkerFor(parent));
    var slots = Object.create(null), valid = true;
    lines.forEach(function (line) {
      var match = /^mag2:([A-Za-z0-9_-]+)-([1-3])$/.exec(rawMarkerFor(line));
      if (!match || match[1] !== marker.bundleId) return;
      var slot = Number(match[2]);
      if (rawMarkerFor(line).length > 69 || slot > packCount || quantityFor(line) !== 1 || !propertiesFor(line)._magnano || line.selling_plan_allocation || parentKeyFor(line) || slots[slot]) {
        valid = false;
        return;
      }
      slots[slot] = line;
    });
    return valid ? slots : null;
  }

  function completeByoCases(children, packCount, magSlots) {
    if (!magSlots) return false;
    var componentsBySlot = {};
    var valid = true;
    children.forEach(function (entry) {
      if (entry.marker.role !== 'case') return;
      if (magSlots[entry.marker.slot]) { valid = false; return; }
      if (quantityFor(entry.item) !== 1) {
        valid = false;
        return;
      }
      var slotComponents = componentsBySlot[entry.marker.slot] || {};
      if (slotComponents[entry.marker.component]) {
        valid = false;
        return;
      }
      slotComponents[entry.marker.component] = true;
      componentsBySlot[entry.marker.slot] = slotComponents;
    });
    if (!valid || Object.keys(componentsBySlot).length + Object.keys(magSlots).length !== packCount) return false;
    for (var slot = 1; slot <= packCount; slot += 1) {
      if (magSlots[slot]) continue;
      var components = Object.keys(componentsBySlot[slot] || {}).map(Number).sort(function (left, right) { return left - right; });
      if (!components.length) return false;
      for (var index = 0; index < components.length; index += 1) {
        if (components[index] !== index + 1) return false;
      }
    }
    return true;
  }

  function sortByoChildren(entries) {
    return entries.slice().sort(function (left, right) {
      var roleDifference = BYO_ROLE_ORDER[left.marker.role] - BYO_ROLE_ORDER[right.marker.role];
      if (roleDifference) return roleDifference;
      if (left.marker.role === 'case') {
        return left.marker.slot - right.marker.slot || left.marker.component - right.marker.component;
      }
      return left.index - right.index;
    });
  }

  function analyzeByo(items) {
    var lines = Array.isArray(items) ? items : [];
    var groups = {};
    lines.forEach(function (item, index) {
      var marker = parseByoMarker(rawMarkerFor(item));
      if (!item || !item.key || !isAuthorizedByoParent(item, marker)) return;
      groups[String(item.key)] = { family: 'byo2', parent: item, parentIndex: index, marker: marker, children: [], valid: true };
    });
    lines.forEach(function (item, index) {
      var parentKey = parentKeyFor(item);
      if (!parentKey || !groups[parentKey]) return;
      var group = groups[parentKey];
      var marker = parseByoMarker(rawMarkerFor(item));
      if (!marker || marker.role === 'parent' || !sameByoIdentity(marker, group.marker) || item.selling_plan_allocation) {
        group.valid = false;
        return;
      }
      group.children.push({ item: item, index: index, marker: marker });
    });
    Object.keys(groups).forEach(function (parentKey) {
      var group = groups[parentKey];
      var rule = BYO_CARRIER_RULES[group.marker.carrierVariantId];
      var freeNanoQuantity = group.children.reduce(function (total, entry) {
        return total + (entry.marker.role === 'free_nano' ? quantityFor(entry.item) : 0);
      }, 0);
      var magSlots = magnanoSlots(group.parent, lines, group.marker.packCount);
      group.magSlots = magSlots || {};
      var matchingParents = Object.keys(groups).filter(function (key) {
        return groups[key].marker.bundleId === group.marker.bundleId;
      });
      group.valid = group.valid
        && matchingParents.length === 1
        && (group.children.length > 0 || (magSlots && Object.keys(magSlots).length > 0))
        && freeNanoQuantity <= rule.freeNanoAllowance
        && completeByoCases(group.children, group.marker.packCount, magSlots);
      group.children = sortByoChildren(group.children);
    });
    return groups;
  }

  function monthlyMarkerSignal(item) {
    return rawMarkerFor(item).indexOf('mon2:') === 0;
  }

  function monthlySizeCode(item) {
    var match = /^SPC-(WXSPC|WPC|WVC|WVXC|WV2XC)-[A-Z0-9][A-Z0-9_-]*$/.exec(skuFor(item));
    return match ? match[1] : null;
  }

  function matchesRule(item, productId, rule) {
    return !!rule
      && productIdFor(item) === productId
      && variantIdFor(item) === rule.id
      && skuFor(item) === rule.sku;
  }

  function isMonthlyLid(item, sizeCode) {
    return matchesRule(item, MONTHLY_LID_PRODUCT_ID, MONTHLY_LID_RULES[sizeCode]);
  }

  function isMonthlyPocket(item, sizeCode) {
    return matchesRule(item, MONTHLY_POCKET_PRODUCT_ID, MONTHLY_POCKET_RULES[sizeCode]);
  }

  function analyzeMonthly(items) {
    var lines = Array.isArray(items) ? items : [];
    var candidates = {};
    var duplicateBundleIds = {};
    var validLineKeys = {};
    var invalidLineKeys = {};

    lines.forEach(function (item, index) {
      if (!item || !item.key || parentKeyFor(item)) return;
      var marker = parseMonthlyMarker(rawMarkerFor(item));
      if (!monthlyMarkerSignal(item) && !isMonthlyCarrier(item)) return;
      candidates[String(item.key)] = {
        family: 'mon2',
        parent: item,
        parentIndex: index,
        marker: marker,
        children: [],
        sizeCode: null,
        lid: null,
        pocket: null,
        valid: true,
        issues: []
      };
      if (marker && marker.role === 'parent') {
        duplicateBundleIds[marker.bundleId] = (duplicateBundleIds[marker.bundleId] || 0) + 1;
      }
    });

    Object.keys(candidates).forEach(function (parentKey) {
      var group = candidates[parentKey];
      var parent = group.parent;
      var marker = group.marker;
      var parentValid = !!marker
        && marker.role === 'parent'
        && isMonthlyCarrier(parent)
        && productIdFor(parent) === MONTHLY_CARRIER_PRODUCT_ID
        && quantityFor(parent) === 1
        && lineAmount(parent, 'line_price', 'price') === 0
        && !parent.selling_plan_allocation
        && !parentKeyFor(parent)
        && duplicateBundleIds[marker.bundleId] === 1;
      if (!parentValid) {
        group.valid = false;
        group.issues.push('invalid_parent');
      }

      var attached = [];
      lines.forEach(function (item, index) {
        if (parentKeyFor(item) === parentKey) attached.push({ item: item, index: index, marker: parseMonthlyMarker(rawMarkerFor(item)) });
      });
      group.children = attached;

      var slots = {};
      var sizeCodes = {};
      var cases = [];
      var lids = [];
      var pockets = [];
      attached.forEach(function (entry) {
        var item = entry.item;
        var childMarker = entry.marker;
        if (!childMarker
          || childMarker.role === 'parent'
          || !marker
          || childMarker.bundleId !== marker.bundleId
          || quantityFor(item) !== 1
          || item.selling_plan_allocation) {
          group.valid = false;
          group.issues.push('invalid_child');
          return;
        }
        if (childMarker.role === 'case') {
          var sizeCode = monthlySizeCode(item);
          if (!childMarker.slot
            || slots[childMarker.slot]
            || productIdFor(item) !== MONTHLY_CASE_PRODUCT_ID
            || !sizeCode
            || originalLineAmount(item) <= 0) {
            group.valid = false;
            group.issues.push('invalid_case');
            return;
          }
          slots[childMarker.slot] = true;
          sizeCodes[sizeCode] = true;
          cases.push(entry);
          return;
        }
        if (childMarker.role === 'lid') lids.push(entry);
        else if (childMarker.role === 'pocket') pockets.push(entry);
        else {
          group.valid = false;
          group.issues.push('unknown_role');
        }
      });

      var sizeKeys = Object.keys(sizeCodes);
      if (cases.length !== 4 || Object.keys(slots).length !== 4 || sizeKeys.length !== 1) {
        group.valid = false;
        group.issues.push('incomplete_cases');
      }
      group.sizeCode = sizeKeys.length === 1 ? sizeKeys[0] : null;
      if (lids.length > 1 || pockets.length > 1) {
        group.valid = false;
        group.issues.push('duplicate_addon');
      }
      if (lids.length === 1) {
        var lid = lids[0].item;
        if (!isMonthlyLid(lid, group.sizeCode)
          || lineAmount(lid, 'line_price', 'price') !== 0) {
          group.valid = false;
          group.issues.push('invalid_lid');
        }
      }
      if (pockets.length === 1) {
        var pocket = pockets[0].item;
        if (!isMonthlyPocket(pocket, group.sizeCode)
          || lineAmount(pocket, 'line_price', 'price') !== 0) {
          group.valid = false;
          group.issues.push('invalid_pocket');
        }
      }
      group.lid = lids[0] || null;
      group.pocket = pockets[0] || null;
      group.children = cases.sort(function (left, right) { return left.marker.slot - right.marker.slot; })
        .concat(lids, pockets);

      if (group.valid) {
        validLineKeys[parentKey] = true;
        attached.forEach(function (entry) { validLineKeys[String(entry.item.key)] = true; });
      } else {
        invalidLineKeys[parentKey] = true;
        attached.forEach(function (entry) { invalidLineKeys[String(entry.item.key)] = true; });
      }
    });

    lines.forEach(function (item) {
      var key = String(item && item.key || '');
      var relationship = parentKeyFor(item);
      var parent = relationship && lines.find(function (candidate) { return String(candidate && candidate.key || '') === relationship; });
      var attachedToMonthlySignal = !!parent && (monthlyMarkerSignal(parent) || isMonthlyCarrier(parent));
      if ((monthlyMarkerSignal(item) || isMonthlyCarrier(item) || attachedToMonthlySignal) && !validLineKeys[key]) {
        invalidLineKeys[key] = true;
      }
    });

    var validGroups = {};
    Object.keys(candidates).forEach(function (key) {
      if (candidates[key].valid) validGroups[key] = candidates[key];
    });
    return {
      groups: validGroups,
      candidates: candidates,
      invalidLineKeys: invalidLineKeys,
      hasInvalid: Object.keys(invalidLineKeys).length > 0
    };
  }

  function visiblePropertyArray(item) {
    if (item && Array.isArray(item.propertyArray)) {
      return item.propertyArray.filter(function (property) {
        return property && property.name && property.name.charAt(0) !== '_' && property.value != null && String(property.value).trim() !== '';
      });
    }
    var properties = propertiesFor(item);
    return Object.keys(properties).filter(function (name) {
      return name.charAt(0) !== '_' && properties[name] != null && String(properties[name]).trim() !== '';
    }).map(function (name) { return { name: name, value: properties[name] }; });
  }

  function optionValue(item, index) {
    if (item && Array.isArray(item.variant_options)) return String(item.variant_options[index] || '');
    if (item && Array.isArray(item.options_with_values) && item.options_with_values[index]) {
      return String(item.options_with_values[index].value || '');
    }
    return '';
  }

  function byoRoleLabel(marker) {
    if (marker.role === 'free_nano') return 'Free Nano';
    if (marker.role === 'lid') return 'Lid Engraving';
    if (marker.role === 'pocket') return 'Pocket Engraving';
    if (marker.role === 'gift') return 'Gift';
    return 'Case ' + marker.slot + (marker.component > 1 ? '.' + marker.component : '');
  }

  function monthlyRoleLabel(marker, item, sizeCode) {
    if (marker.role === 'lid') return 'Lid Engraving';
    if (marker.role === 'pocket') return 'Pocket Engraving';
    var caseName = optionValue(item, 0) || MONTHLY_SIZE_NAMES[sizeCode] || 'Pill Case';
    caseName = String(caseName).replace(/^Weekly\s+/i, '').trim() || 'Pill Case';
    return 'Week ' + marker.slot + ' ' + caseName;
  }

  function createBaseView(item, index, monthlyAnalysis) {
    return Object.assign({}, item, {
      nested_line_index: index + 1,
      nested_bundle: false,
      nested_family: '',
      nested_quantity_locked: isQuantityLocked(item),
      nested_propertyArray: visiblePropertyArray(item),
      nested_bundle_invalid: !!monthlyAnalysis.invalidLineKeys[String(item && item.key || '')],
      byo2_line_index: index + 1,
      byo2_bundle: false,
      byo2_has_magnano: false,
      nested_bundle_id: '',
      byo2_propertyArray: visiblePropertyArray(item)
    });
  }

  function applyByoView(view, group) {
    var entries = group.children.concat(Object.keys(group.magSlots).map(function (slot) {
      return { item: group.magSlots[slot], index: -1, magnano: true,
        marker: { role: 'case', slot: Number(slot), component: 1 } };
    }));
    var children = sortByoChildren(entries).map(function (entry) {
      var child = Object.assign({}, entry.item, {
        nested_marker: entry.marker,
        nested_role_label: byoRoleLabel(entry.marker),
        nested_hide_product_title: entry.marker.role === 'free_nano',
        propertyArray: visiblePropertyArray(entry.item),
        byo2_marker: entry.marker,
        byo2_role_label: byoRoleLabel(entry.marker),
        byo2_hide_product_title: entry.marker.role === 'free_nano'
      });
      var allocations = child.line_level_discount_allocations || child.discount_allocations || [];
      var allocated = allocations.reduce(function (sum, allocation) { return sum + (Number(allocation.amount) || 0); }, 0);
      child.final_line_price = Math.min(lineAmount(child, 'final_line_price', 'final_price'), Math.max(0, originalLineAmount(child) - allocated));
      child.nested_engraving = [];
      if (entry.magnano) {
        try {
          var data = JSON.parse(propertiesFor(child)._magnano);
          (data.c || []).forEach(function (_id, index) {
            var lid = String((data.l || [])[index] || ''), pocket = String((data.p || [])[index] || '');
            if (lid || pocket) child.nested_engraving.push({ label: 'Case ' + (index + 1), lid: lid, pocket: pocket });
          });
        } catch (_error) { /* The cart can still show the set when its details are unavailable. */ }
      }
      return child;
    });
    var total = children.reduce(function (sum, child) { return sum + lineAmount(child, 'final_line_price', 'final_price'); }, 0);
    var parentProperties = propertiesFor(group.parent);
    var parentPropertyArray = [BYO_BUNDLE_NUMBER_KEY, 'Skip Free Nano'].filter(function (name) {
      return name === 'Skip Free Nano'
        ? parentProperties[name] === 'Yes'
        : parentProperties[name] != null && String(parentProperties[name]).trim() !== '';
    }).map(function (name) { return { name: name, value: parentProperties[name] }; });
    view.nested_bundle = true;
    view.nested_family = 'byo2';
    view.byo2_has_magnano = Object.keys(group.magSlots).length > 0;
    view.nested_bundle_id = group.marker.bundleId;
    view.product_title = group.parent.variant_title || group.parent.title || group.marker.packCount + '-Pack Bundle';
    view.title = view.product_title;
    view.nested_children = children;
    view.nested_propertyArray = parentPropertyArray;
    view.byo2_bundle = true;
    view.byo2_children = children;
    view.byo2_propertyArray = parentPropertyArray;
    view.price = total;
    view.final_price = total;
    view.line_price = total;
    view.final_line_price = total;
    return view;
  }

  function applyMonthlyView(view, group) {
    var children = group.children.map(function (entry) {
      var childProperties = visiblePropertyArray(entry.item).filter(function (property) {
        return property.name !== MONTHLY_BUNDLE_NUMBER_KEY;
      });
      if (entry.marker.role === 'case') {
        var dotwPropertyName = 'Pill Case #' + entry.marker.slot + ' - DOTW';
        childProperties = childProperties.map(function (property) {
          return property.name === dotwPropertyName
            ? { name: 'DOTW', value: property.value }
            : property;
        });
      }
      var child = Object.assign({}, entry.item, {
        nested_marker: entry.marker,
        nested_role_label: monthlyRoleLabel(entry.marker, entry.item, group.sizeCode),
        nested_hide_product_title: entry.marker.role === 'case',
        nested_size: '',
        nested_color: entry.marker.role === 'case' ? optionValue(entry.item, 1) : '',
        propertyArray: childProperties
      });
      if (entry.marker.role === 'case') child.variant_title = '';
      return child;
    });
    var total = children.reduce(function (sum, child) { return sum + lineAmount(child, 'final_line_price', 'final_price'); }, 0);
    view.nested_bundle = true;
    view.nested_family = 'mon2';
    view.nested_children = children;
    view.nested_propertyArray = visiblePropertyArray(group.parent).filter(function (property) {
      return property.name === MONTHLY_BUNDLE_NUMBER_KEY;
    });
    view.nested_bundle_number = propertiesFor(group.parent)[MONTHLY_BUNDLE_NUMBER_KEY] || '';
    var monthlyTitle = String(group.parent.variant_title || '').trim() || 'Monthly Pill Case Bundle';
    view.product_title = monthlyTitle;
    view.title = monthlyTitle;
    view.variant_title = '';
    view.url = MONTHLY_CARRIER_URLS[variantIdFor(group.parent)];
    view.price = total;
    view.final_price = total;
    view.line_price = total;
    view.final_line_price = total;
    return view;
  }

  function analyze(items) {
    var byoGroups = analyzeByo(items);
    var monthly = analyzeMonthly(items);
    return { byo2: byoGroups, mon2: monthly.groups, monthly: monthly, hasInvalid: monthly.hasInvalid };
  }

  function miniCartItems(items) {
    var lines = Array.isArray(items) ? items : [];
    var analysis = analyze(lines);
    var hiddenKeys = {};
    Object.keys(analysis.byo2).forEach(function (key) {
      var group = analysis.byo2[key];
      if (group.valid) {
        group.children.forEach(function (entry) { hiddenKeys[String(entry.item.key)] = true; });
        Object.keys(group.magSlots).forEach(function (slot) { hiddenKeys[String(group.magSlots[slot].key)] = true; });
      }
    });
    Object.keys(analysis.mon2).forEach(function (key) {
      analysis.mon2[key].children.forEach(function (entry) { hiddenKeys[String(entry.item.key)] = true; });
    });

    return lines.reduce(function (result, item, index) {
      var key = String(item && item.key || '');
      if (hiddenKeys[key]) return result;
      var view = createBaseView(item, index, analysis.monthly);
      if (analysis.mon2[key]) applyMonthlyView(view, analysis.mon2[key]);
      else if (analysis.byo2[key] && analysis.byo2[key].valid) applyByoView(view, analysis.byo2[key]);
      result.push(view);
      return result;
    }, []);
  }

  function normalizedItemCount(cartOrItems) {
    var items = Array.isArray(cartOrItems)
      ? cartOrItems
      : cartOrItems && Array.isArray(cartOrItems.items)
        ? cartOrItems.items
        : [];
    var count = items.reduce(function (total, item) { return total + quantityFor(item); }, 0);
    var analysis = analyze(items);
    Object.keys(analysis.byo2).forEach(function (key) {
      if (analysis.byo2[key].valid) count -= quantityFor(analysis.byo2[key].parent);
    });
    Object.keys(analysis.mon2).forEach(function (key) { count -= quantityFor(analysis.mon2[key].parent); });
    return Math.max(0, count);
  }

  function hasInvalidMonthly(cartOrItems) {
    var items = Array.isArray(cartOrItems)
      ? cartOrItems
      : cartOrItems && Array.isArray(cartOrItems.items)
        ? cartOrItems.items
        : [];
    return analyzeMonthly(items).hasInvalid;
  }

  function updateCount(cartOrItems, root) {
    var documentRoot = root || (typeof document !== 'undefined' ? document : null);
    if (!documentRoot || typeof documentRoot.querySelectorAll !== 'function') return;
    var count = normalizedItemCount(cartOrItems);
    var invalid = hasInvalidMonthly(cartOrItems);
    Array.prototype.forEach.call(documentRoot.querySelectorAll('[data-nested-bundle-cart-count], [data-byo2-cart-count]'), function (element) {
      element.textContent = count;
      if (element.hasAttribute('data-cart-count-hide-zero')) element.hidden = count === 0;
    });
    Array.prototype.forEach.call(documentRoot.querySelectorAll('[data-nested-bundle-checkout]'), function (button) {
      var termsId = button.getAttribute('data-terms-checkbox-id');
      var terms = termsId && typeof documentRoot.getElementById === 'function' ? documentRoot.getElementById(termsId) : null;
      var otherInvalid = button.getAttribute('data-other-bundle-invalid') === 'true';
      var disabled = invalid || otherInvalid || !!(terms && !terms.checked);
      button.disabled = disabled;
      button.setAttribute('aria-disabled', disabled ? 'true' : 'false');
    });
    Array.prototype.forEach.call(documentRoot.querySelectorAll('[data-monthly-bundle-invalid-message]'), function (message) {
      message.hidden = !invalid;
    });
    Array.prototype.forEach.call(documentRoot.querySelectorAll('[data-additional-checkout-buttons]'), function (container) {
      container.hidden = invalid;
    });
  }

  function installRivets(rivets) {
    if (!rivets || !rivets.formatters) return;
    rivets.formatters.nestedBundleCartItems = miniCartItems;
    rivets.formatters.nestedBundleItemCount = normalizedItemCount;
    rivets.formatters.nestedBundleHasInvalid = hasInvalidMonthly;
    rivets.formatters.byo2CartItems = miniCartItems;
    rivets.formatters.byo2ItemCount = normalizedItemCount;
  }

  function getNextByoBundleNumber(items) {
    var parentCount = 0;
    var highestNumber = 0;
    (items || []).forEach(function (item) {
      var marker = parseByoMarker(rawMarkerFor(item));
      if (!isAuthorizedByoParent(item, marker)) return;
      parentCount += 1;
      var rawNumber = propertiesFor(item)[BYO_BUNDLE_NUMBER_KEY];
      if (rawNumber == null || String(rawNumber).trim() === '') return;
      var number = positiveInteger(rawNumber);
      if (number == null) throw new Error('An existing BYO bundle has an invalid bundle number.');
      highestNumber = Math.max(highestNumber, number);
    });
    return Math.max(parentCount, highestNumber) + 1;
  }

  var api = {
    BYO_CARRIER_RULES: BYO_CARRIER_RULES,
    MONTHLY_CARRIER_URLS: MONTHLY_CARRIER_URLS,
    MONTHLY_LID_RULES: MONTHLY_LID_RULES,
    MONTHLY_POCKET_RULES: MONTHLY_POCKET_RULES,
    isMonthlyCarrier: isMonthlyCarrier,
    isModernMarker: isModernMarker,
    isQuantityLocked: isQuantityLocked,
    parseMarker: parseMarker,
    parseByoMarker: parseByoMarker,
    parseMonthlyMarker: parseMonthlyMarker,
    analyzeByo: analyzeByo,
    analyzeMonthly: analyzeMonthly,
    analyze: analyze,
    miniCartItems: miniCartItems,
    normalizedItemCount: normalizedItemCount,
    hasInvalidMonthly: hasInvalidMonthly,
    updateCount: updateCount,
    installRivets: installRivets
  };

  api.byo2 = {
    CARRIER_RULES: BYO_CARRIER_RULES,
    BYO_BUNDLE_NUMBER_KEY: BYO_BUNDLE_NUMBER_KEY,
    parseMarker: parseByoMarker,
    getNextBundleNumber: getNextByoBundleNumber,
    analyze: analyzeByo,
    miniCartItems: miniCartItems,
    normalizedItemCount: normalizedItemCount,
    updateCount: updateCount,
    installRivets: installRivets
  };

  return api;
});
